import {
  wixCliAction,
  wixCliAppFlowStepsAnswers,
} from '@wix/bi-logger-dev-tools-data/v2';
import type { BiLogger, Flow } from '@wix/cli-telemetry';

export const wixCliAstroBiEvents = (biLogger: BiLogger) => ({
  cliAction: ({
    questionKey,
    question,
    action,
    key,
    additionalInfo,
  }: {
    questionKey: string;
    question: string;
    action: string;
    key: string;
    additionalInfo?: Record<string, unknown>;
  }) => {
    void biLogger.report(
      wixCliAction({
        flow: 'Astro' satisfies Flow,
        questionKey,
        question,
        action,
        key,
        additionalInfo: JSON.stringify(additionalInfo),
      })
    );
  },
  cliStepBack: ({
    additionalInfo,
  }: {
    additionalInfo?: Record<string, unknown>;
  }) => {
    void biLogger.report(
      wixCliAction({
        flow: 'Astro' satisfies Flow,
        action: 'goToPreviousStep',
        key: 'Esc',
        additionalInfo: JSON.stringify(additionalInfo),
      })
    );
  },
  cliFlowStepAnswered: ({
    question,
    questionKey,
    answer,
    additionalInfo,
  }: {
    question: string;
    questionKey: string;
    answer: string;
    additionalInfo?: Record<string, unknown>;
  }) => {
    void biLogger.report(
      wixCliAppFlowStepsAnswers({
        flow: 'Astro' satisfies Flow,
        questionKey,
        question,
        answer,
        additionalInfo: JSON.stringify(additionalInfo),
      })
    );
  },
});
